var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trading-container"},[_c('trading-slider',_vm._b({attrs:{"routers":_vm.TradingRouter,"company-click-handler":_vm.companyClickHandler,"hideLeft":_vm.hideLeft,"isZnl":_vm.isZnl},on:{"route-change":function (routeName) {
        _vm.$emit('route-change', routeName);
      }}},'trading-slider',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }